import { render } from "./SuperAdminView.vue?vue&type=template&id=7d0bd675&scoped=true"
import script from "./SuperAdminView.vue?vue&type=script&lang=js"
export * from "./SuperAdminView.vue?vue&type=script&lang=js"

import "./SuperAdminView.vue?vue&type=style&index=0&id=7d0bd675&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0bd675"]])

export default __exports__